

// Generic sort methods. If you want something user or course specific, make another helper. This one is generic.
angular.module('trainerWebApp.services').factory('sortHelper', function () {
  var _sortField;
  var _sortSign;

  function field(field) {
    _sortField = field;
    return publicMethods;
  }

  function asc() {
    _sortSign = 1;
    return publicMethods;
  }

  function desc() {
    _sortSign = -1;
    return publicMethods;
  }

  function numericSorter() {
    return function numericPropertySorter(a, b) {
      return sortByNumber(a[_sortField], b[_sortField]);
    }
  }

  function sortByNumber(a, b) {
    a = a || 0, b = b || 0;
    return a == b ?  0 : (a > b ? 1 : -1) * _sortSign;
  }

  function stringSorter() {
    return function stringPropertySorter(a, b) {
      return sortByString(a[_sortField], b[_sortField]);
    }
  }

  function sortByString(a, b) {
    a = a || '', b = b || '';
    a = a.toLowerCase(), b = b.toLowerCase();
    return a == b ?  0 : (a > b ? 1 : -1) * _sortSign;
  }

  function setup() {
    _sortField = null;
    _sortSign = 1;
  }

  setup();

  // non-chained methods

  function getNumericPropertySorter(params) {
    _sortSign = params.asc ? 1 : -1;
    _sortField = params.field;
    return function numericPropertySorter(a, b) {
      return sortByNumber(a[_sortField], b[_sortField]);
    }
  }

  function getStringPropertySorter(params) {
    _sortSign = params.asc ? 1 : -1;
    _sortField = params.field;
    return function numericPropertySorter(a, b) {
      return sortByString(a[_sortField], b[_sortField]);
    }
  }

  function getDataFromGridItem(item) {
    return item._parent || item;
  }

  var publicMethods = {
    field: field,
    asc: asc,
    desc: desc,
    numericSorter: numericSorter,
    stringSorter: stringSorter,
    // non-chained methods
    getDataFromGridItem: getDataFromGridItem,
    getNumericPropertySorter: getNumericPropertySorter,
    getStringPropertySorter: getStringPropertySorter
  };

  return publicMethods;
});
